/**
 * NOTE: This module is used in student header.
 */

import * as React from 'react';

import utils from 'Utils';

export default class HeaderRoomName extends React.Component {
  render() {
    let displayName = this.props.roomName;

    if (window.innerWidth < 375) {
      displayName = utils.ellipsify(displayName, 25);
    }

    return (
      <div
        id="header-room-name-container"
        className={
          this.props.roomName && this.props.roomName.length > 25
            ? 'long-room-name'
            : ''
        }
      >
        <div id="header-room-name" className="no-menu">
          <span key="1" className="font-mono">
            {displayName}
          </span>
        </div>
      </div>
    );
  }
}
